import React, { Suspense, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { SiteHeader } from './SiteHeader';
import { SiteFooter } from './SiteFooter';
import { PageLoader } from '../PageLoader';
export function Layout() {
  const {
    pathname,
    hash
  } = useLocation();
  useEffect(() => {
    if (hash) {
      const t = window.setTimeout(() => {
        document.getElementById(hash.slice(1))?.scrollIntoView({
          block: 'start'
        });
      }, 60);
      return () => window.clearTimeout(t);
    }
    window.scrollTo(0, 0);
    return undefined;
  }, [pathname, hash]);
  return <div className="flex min-h-screen w-full flex-col bg-bg text-ink" data-id="element-224" data-mp="3f11b6q2zkjgn">
      <SiteHeader data-id="element-225" data-mp="3ezq2qcylinj7" />
      <main className="flex-1" data-id="element-226" data-mp="3j2wchukx2wuf">
        <Suspense fallback={<PageLoader data-id="element-228" data-mp="3j2d1yyxljaqf" />} data-id="element-227" data-mp="3j1uybh8ltu8h">
          <Outlet data-id="element-229" data-mp="1knji6njtaue8" />
        </Suspense>
      </main>
      <SiteFooter data-id="element-230" data-mp="1kouxnkmmdql6" />
    </div>;
}